module.exports = __webpack_public_path__ + "static/media/changing-room.b145b02a.svg";